export default "__VITE_ASSET__Ng002W0b__"